import { useContext } from "react";
import { UserContext, UserContextType } from "./UserContextComponent";

export const useUser = (): UserContextType => {
    const context = useContext(UserContext);
    if (context === undefined) {
      throw new Error('useProject must be used within a UserProjectProvider');
    }
    return context;
  };